import React, { useState } from 'react';
import { Button, Card } from './Primitives';
import { Icon } from './Icon';

const DEFAULT_APK_URL =
  '/downloads/english-forge-365.apk';

export function PlatformAccess() {
  const [status, setStatus] = useState('');

  const apkUrl =
    String(
      import.meta.env.VITE_ANDROID_APK_URL ??
        DEFAULT_APK_URL,
    ).trim();

  const telegramUrl =
    String(
      import.meta.env.VITE_TELEGRAM_MINIAPP_URL ?? '',
    ).trim();

  const downloadAndroid = async () => {
    setStatus('APK tekshirilmoqda...');

    try {
      if (apkUrl.startsWith('/')) {
        const check = await fetch(apkUrl, {
          method: 'HEAD',
          cache: 'no-store',
        });

        if (!check.ok) {
          setStatus(
            'Android APK hali serverga joylanmagan. Android build bosqichida avtomatik ulaymiz.',
          );
          return;
        }
      }

      const link = document.createElement('a');
      link.href = apkUrl;
      link.download = 'English-Forge-365.apk';
      link.rel = 'noopener';

      document.body.appendChild(link);
      link.click();
      link.remove();

      setStatus(
        'English Forge 365 Android ilovasi yuklanmoqda.',
      );
    } catch {
      setStatus(
        'APK yuklashni boshlab bo‘lmadi. Android build hali serverga joylanmagan bo‘lishi mumkin.',
      );
    }
  };

  const openTelegram = () => {
    if (!telegramUrl) {
      setStatus(
        'Telegram Mini App havolasi hali production sozlamasiga kiritilmagan.',
      );
      return;
    }

    window.open(
      telegramUrl,
      '_blank',
      'noopener,noreferrer',
    );
  };

  return (
    <Card className="platform-access-card">
      <div className="platform-access-head">
        <div>
          <span className="eyebrow">
            BARCHA QURILMALARDA
          </span>

          <h3>English Forge siz bilan hamma joyda</h3>

          <p>
            Darslaringiz va progress bitta akkaunt orqali
            Web, Android va Telegram Mini App o‘rtasida
            sinxronlanadi.
          </p>
        </div>

        <picture>
          <source srcSet="/brand/app_icon_96.webp?v=3.1.1-audit 96w, /brand/app_icon_192.webp?v=3.1.1-audit 192w" sizes="72px" type="image/webp" />
          <img
            className="platform-brand-icon"
            src="/brand/app_icon.png?v=3.1.1-audit"
            alt=""
            width={96}
            height={96}
            loading="lazy"
            decoding="async"
          />
        </picture>
      </div>

      <div className="platform-access-grid">
        <div className="platform-access-item">
          <div className="platform-access-icon">
            <Icon name="download" size={24}/>
          </div>

          <div className="platform-access-copy">
            <strong>Android ilovasi</strong>
            <span>
              English Forge 365 mobil ilovasini APK
              ko‘rinishida to‘g‘ridan-to‘g‘ri yuklab oling.
            </span>
          </div>

          <Button onClick={() => void downloadAndroid()}>
            <Icon name="download" size={17}/>
            Android uchun yuklab olish
          </Button>
        </div>

        <div className="platform-access-item">
          <div className="platform-access-icon">
            <Icon name="cloud" size={24}/>
          </div>

          <div className="platform-access-copy">
            <strong>Telegram Mini App</strong>
            <span>
              Telegram ichidan tez kirish, kundalik dars va
              progressga darhol qaytish.
            </span>
          </div>

          <Button
            variant="secondary"
            onClick={openTelegram}
          >
            <Icon name="arrow" size={17}/>
            Telegram Mini App’da ochish
          </Button>
        </div>
      </div>

      {status && (
        <div className="platform-access-status">
          {status}
        </div>
      )}
    </Card>
  );
}
